import { atom } from 'recoil';

import { Atoms } from '../constants';

export const loaderStateAtom = atom({
  key: Atoms.loaderState,
  default: false,
});
